import getAllConsumer from "./getAllConsumer.api"
import getConsumerScanListing from "./getConsumerScanListing.api"
import getConsumerProfile from "./getConsumerProfile.api"
import fetchAllScanTrack from "./fetchAllScanTrack.api"
import getConsumerGiftRedemptionListing from "./getConsumerGiftRedemptionListing.api"
import getGiftDropdown from "./getGiftDropdown.api"
import getConsumerLoyaltyPointHistory from "./getConsumerLoyaltyPointHistory.api"
import getCampaignProductDropdown from "./getCampaignProductDropdown.api"
import getConsumerCampaignListing from "./getConsumerCampaignListing.api"
import updateConsumerLoyaltyPoint from "./updateConsumerLoyaltyPoint.api"
import getConsumerCampaignV2Listing from "./getConsumerCampaignV2Listing.api"
import getCampaignV2ProductDropdown from "./getCampaignV2ProductDropdown.api"

const consumerApi = {
  getAllConsumer,
  getConsumerScanListing,
  getConsumerProfile,
  fetchAllScanTrack,
  getConsumerGiftRedemptionListing,
  getGiftDropdown,
  getConsumerLoyaltyPointHistory,
  getCampaignProductDropdown,
  getConsumerCampaignListing,
  updateConsumerLoyaltyPoint,
  getConsumerCampaignV2Listing,
  getCampaignV2ProductDropdown
}

export default consumerApi
